import { Injectable, OnDestroy, WritableSignal, inject, signal } from '@angular/core'

import { Observable, fromEvent, map, tap } from 'rxjs'

import { SseMessageType } from '@flowx/core-sdk'
import { CopyResourceApi } from '@flowx/designer/shared/api/copy-resource.api'
import {
  CopyResourceParams,
  CopyResourceSseMessageType,
  DuplicateResourcePayload,
} from '@flowx/designer/shared/model/copy-resource.model'

import { ToastMessageService } from './toast-message.service'

@Injectable()
export class DuplicateResourceService implements OnDestroy {
  #copyResourceApi = inject(CopyResourceApi)
  #sseConnection: EventSource
  #toastMsgService = inject(ToastMessageService)
  params: WritableSignal<CopyResourceParams> = signal(null)
  loading = signal(false)

  ngOnDestroy(): void {
    if (this.#sseConnection) {
      this.#sseConnection.close()
    }
  }

  duplicateResource(newResourceName: string): Observable<{ copyId: string }> {
    const payload = {
      newResourceName,
    } satisfies DuplicateResourcePayload
    return this.#copyResourceApi.duplicateResource(this.params(), payload)
  }

  sseConnection(copyId: string, resourceType: string): Observable<CopyResourceSseMessageType> {
    if (this.#sseConnection) {
      this.#sseConnection.close()
    }

    this.#sseConnection = this.#copyResourceApi.initSseConnection(copyId)
    return fromEvent<MessageEvent>(this.#sseConnection, SseMessageType.Data).pipe(
      tap(() => this.loading.set(false)),
      map((event: MessageEvent) => {
        try {
          const data = JSON.parse(event.data)
          if (data.status === CopyResourceSseMessageType.SUCCESS) {
            this.#toastMsgService.showSuccessMessage(` ${resourceType} duplicated successfully`)
          }
          return data.status
        } catch (error) {
          return CopyResourceSseMessageType.ERROR
        }
      })
    )
  }
}
